const truncateUrl = (fullUrl?: string | null): string => {
  if (!fullUrl || typeof fullUrl !== 'string') return '';

  const cleanedUrl = fullUrl.trim();
  if (!cleanedUrl) return '';

  // Ensure we can parse with URL
  const addProtocolIfNeeded = (urlString: string): string => {
    if (/^https?:\/\//i.test(urlString)) return urlString;
    if (/^www\./i.test(urlString)) return `https://${urlString}`;
    // If it looks like a domain (has a dot), try assuming https
    if (/^[^\s]+\.[^\s]+/.test(urlString)) return `https://${urlString}`;
    return urlString;
  };

  const urlWithProtocol = addProtocolIfNeeded(cleanedUrl);
  try {
    const parsedUrl = new URL(urlWithProtocol);
    const domainName = parsedUrl.hostname.replace(/^www\./i, '');
    return domainName || '';
  } catch {
    // Fallback: best-effort extraction of domain-like token
    const domainMatch = cleanedUrl
      .replace(/^https?:\/\//i, '')
      .replace(/^www\./i, '')
      .match(/^[a-z0-9.-]+\.[a-z.]{2,}/i);
    return domainMatch ? domainMatch[0] : '';
  }
};

export { truncateUrl };
